import styled from "@emotion/styled";
import InterestFormModal from "components/InterestForm/InterestFormModal";
import Layout from "components/Layout";
import Image from "next/image";
import { ReactElement, useState } from "react";
import { Button, colors } from "ui";

import p1 from "../assets/images/f1.png";
import p2 from "../assets/images/f2.png";
import p3 from "../assets/images/f3.png";
import p4 from "../assets/images/f4.png";
import map from "../assets/images/map.png";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    text-align: center;
    color: ${colors.blackText};
  }

  p {
    letter-spacing: 1.2px;
    line-height: 22px;
    font-weight: 500;
    text-align: center;
    color: ${colors.blackText};
  }

  button {
    margin: 20px auto;
  }
`;

const PersonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 50px;
  margin-bottom: 75px;
`;

const Person = styled.div``;

const MapImgWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: 80%;
  padding-bottom: 40%;

  @media (max-width: 700px) {
    width: 100%;
    padding-bottom: 60%;
  }
`;

const AddressInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  max-width: 800px;
  margin: 50px auto 0;

  p {
    text-align: left;
    margin: 0;
  }

  h3 {
    margin-bottom: 6px;
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 20px;
  }
`;

const persons = [
  {
    name: "Zana Ali",
    img: p1,
  },
  {
    name: "Hille Tehini",
    img: p2,
  },
  {
    name: "Rasti Faradj",
    img: p3,
  },
  {
    name: "Henrik Baumardt",
    img: p4,
  },
];

const About = () => {
  const [interestForm, setInterestForm] = useState(false);

  return (
    <>
      <Wrapper>
        <h1>Ett team bestående av oss som förstår tillväxt</h1>
        <p>
          Vår vision är att stärka frisörsalongernas lojalitet mot deras kunder
          genom att öka försäljningen av produkter inom salongen. Vi förstår att
          hår är en mycket personlig och viktig del av människans identitet och
          vi tror att det är frisören som har den bästa kunskapen och känslan
          för just hår. Genom att bygga starka relationer mellan salonger och
          deras kunder kan vi öka förtroendet för frisörsalongerna genom att
          erbjuda de bästa produkterna utifrån deras behov. Vi vill hjälpa
          salonger att fortsätta vara det självklara valet för professionell
          hårvård genom att erbjuda produkter och service av den bästa nivå.
        </p>
        <Button
          aria-label="registrera din salong"
          variant="contained"
          onClick={() => setInterestForm(true)}
        >
          Registrera din salong
        </Button>
        <PersonWrapper>
          {persons.map((person) => (
            <Person key={person.name}>
              <Image
                src={person.img}
                alt="img1"
                width={150}
                height={150}
                style={{ objectFit: "cover", borderRadius: "50%" }}
              />
              <p>
                <strong>{person.name}</strong>
              </p>
            </Person>
          ))}
        </PersonWrapper>
        <h1>Besök oss</h1>
        <MapImgWrapper>
          <Image
            src={map}
            fill
            alt="img1"
            style={{ objectFit: "cover", borderRadius: "16px" }}
          />
        </MapImgWrapper>
        <AddressInfo>
          <div>
            <h3>Adress</h3>
            <p>
              Regeringsgatan 70A
              <br />
              Stockholm, 111 39
              <br />
              Sweden
            </p>
          </div>
          <div>
            <h3>Kontakt</h3>
            <p>{process.env.NEXT_PUBLIC_SUPPORT_EMAIL}</p>
          </div>
        </AddressInfo>
      </Wrapper>
      <InterestFormModal
        open={interestForm}
        onClose={() => setInterestForm(false)}
      />
    </>
  );
};

About.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default About;
